export const purchaseItemDicionary: Record<string, string> = {
  'To carry out the operation it is necessary to have stock available. Check the stock':
    'Para realizar a operação é necessário ter estoque disponível. Verifique o estoque por gentileza!',

  'It is necessary to adjust the invoice settings in the company registration':
    'Informe o tipo de nota fiscal a ser emitido no cadastro de empresa!',

  'Unable to cancel purchase item with generated financial.':
    'Não é possível excluir o item de compra com o financeiro gerado.',
};
